<h1>Select Reciprocity States
  <button
  type="button"
  class="close pull-right"
  aria-label="close"
  (click)="close()"
>
  <span aria-hidden="true">×</span>
</button>
</h1>
<div id="allcontent">
  <div #repocitytooltip id="repocitytooltip" class="addcsstooltips"></div>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 600" class="map-nm">
    <rect
      [attr.fill]="fillStateColor"
      [attr.stroke]="strokeColor"
      x="895"
      y="130"
      width="30"
      height="17"
      id="Ma_1"
      (click)="onUsMapClick('ma')"
      (mouseover)="onHover('Massachusetts', 'ma', $event)"
      (mouseout)="onMouseout()"
      (mouseleave)="onmouseLeave('ma')"
    />
    <rect
      [attr.fill]="fillStateColor"
      [attr.stroke]="strokeColor"
      x="890"
      y="182"
      width="21"
      height="17"
      id="Ri_1"
      (click)="onUsMapClick('ri')"
      (mouseover)="onHover('Rhode Island', 'ri', $event)"
      (mouseout)="onMouseout()"
      (mouseleave)="onmouseLeave('ri')"
    />
    <rect
      [attr.fill]="fillStateColor"
      [attr.stroke]="strokeColor"
      x="869"
      y="196"
      width="21"
      height="18"
      id="ct_1"
      (click)="onUsMapClick('ct')"
      (mouseover)="onHover('Connecticut', 'ct', $event)"
      (mouseout)="onMouseout()"
      (mouseleave)="onmouseLeave('ct')"
    />
    <rect
      [attr.fill]="fillStateColor"
      [attr.stroke]="strokeColor"
      x="851"
      y="216"
      width="21"
      height="18"
      id="Nj_1"
      (click)="onUsMapClick('nj')"
      (mouseover)="onHover('New Jersey', 'nj', $event)"
      (mouseout)="onMouseout()"
      (mouseleave)="onmouseLeave('nj')"
    />
    <rect
      [attr.fill]="fillStateColor"
      [attr.stroke]="strokeColor"
      x="843"
      y="240"
      width="24"
      height="18"
      id="de_1"
      (click)="onUsMapClick('de')"
      (mouseover)="onHover('Delaware', 'de', $event)"
      (mouseout)="onMouseout()"
      (mouseleave)="onmouseLeave('de')"
    />
    <rect
      [attr.fill]="fillStateColor"
      [attr.stroke]="strokeColor"
      x="843"
      y="261"
      width="30"
      height="18"
      id="md_1"
      (click)="onUsMapClick('md')"
      (mouseover)="onHover('Maryland', 'md', $event)"
      (mouseout)="onMouseout()"
      (mouseleave)="onmouseLeave('md')"
    />
    <rect
      [attr.fill]="fillStateColor"
      [attr.stroke]="strokeColor"
      x="817"
      y="82"
      width="27"
      height="18"
      id="vt_1"
      (click)="onUsMapClick('md')"
      (mouseover)="onHover('Maryland', 'md', $event)"
      (mouseout)="onMouseout()"
      (mouseleave)="onmouseLeave('md')"
    />
    <rect
      [attr.fill]="fillStateColor"
      [attr.stroke]="strokeColor"
      x="837"
      y="66"
      width="27"
      height="18"
      id="nh_1"
      (click)="onUsMapClick('nh')"
      (mouseover)="onHover('New Hampshire', 'nh', $event)"
      (mouseout)="onMouseout()"
      (mouseleave)="onmouseLeave('nh')"
    />
    <rect
      [attr.fill]="fillStateColor"
      [attr.stroke]="strokeColor"
      x="361"
      y="562"
      width="24"
      height="18"
      id="hi_1"
      (click)="onUsMapClick('h1')"
      (mouseover)="onHover('Hawaii', 'hi', $event)"
      (mouseout)="onMouseout()"
      (mouseleave)="onmouseLeave('hi')"
    />
    <g>
      <!-- (mouseout)="onMouseout()" -->
      <!-- [ngClass]="{ active: addData == true }" -->

      <path
        style="cursor: pointer"
        *ngFor="let coordinate of Repocitycoordinates; let i = index"
        [attr.id]="coordinate.id"
        [attr.name]="coordinate.name"
        [attr.d]="coordinate.d"
        [attr.fill]="fillStateColor"
        [style.fill]="fillcolor(coordinate.id)"
        [attr.stroke]="strokeColor"
        (click)="onUsMapClick(coordinate.id)"
        (mouseover)="onHover(coordinate.name, coordinate.id, $event)"
        (mouseleave)="onmouseLeave(coordinate.id)"
        (mouseout)="onMouseout()"
      ></path>
      <!-- (click)="onUsMapClick(coordinate.id, $event)"
      (mouseover)="onHover(coordinate.id, $event)"
      (mouseleave)="onmouseLeave(coordinate.id)" -->
      <!-- (mouseleave)="onmouseLeave(coordinate.id)" -->
      <!-- (mouseenter)="onMouseEnter(coordinate.id)" -->
      <!-- (mouseleave)="onmouseLeave(coordinate.id)" -->
      <!-- (mouseenter)="onMouseEnter(coordinate.id)" -->
      <!-- (mouseover)="onHover(coordinate.id, $event)" -->
      <!-- (click)="onUsMapClick(coordinate.id)" -->
      <!-- (click)="onUsMapClick('AL')" -->
      <text
        style="cursor: pointer"
        x="657"
        y="405"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('al')"
        (mouseover)="onHover('Alabama', 'al', $event)"
        (mouseleave)="onmouseLeave('al')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">AL</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="115"
        y="490"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('ak')"
        (mouseover)="onHover('Alaska', 'ak', $event)"
        (mouseleave)="onmouseLeave('ak')"
        (mouseout)="onMouseout()"
      >
        <!-- (click)="onUsMapClick('AK')" -->
        <!-- (mouseover)="onHover('shashank', $event)" -->
        <tspan dy="6.5">AK</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="205"
        y="355"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('az')"
        (mouseover)="onHover('Arizona', 'az', $event)"
        (mouseleave)="onmouseLeave('az')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">AZ</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="547"
        y="367"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('ar')"
        (mouseover)="onHover('Arkansas', 'ar', $event)"
        (mouseleave)="onmouseLeave('ar')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">AR</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="70"
        y="260"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('circle')"
        (mouseover)="onHover('California', 'ca', $event)"
        (mouseleave)="onmouseLeave('ca')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">CA</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="322"
        y="273"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('co')"
        (mouseover)="onHover('Colorado', 'co', $event)"
        (mouseleave)="onmouseLeave('co')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">CO</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="880"
        y="205"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('ct')"
        (mouseover)="onHover('Connecticut', 'ct', $event)"
        (mouseleave)="onmouseLeave('ct')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">CT</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="855"
        y="248"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('de')"
        (mouseover)="onHover('Delaware', 'de', $event)"
        (mouseleave)="onmouseLeave('de')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">DE</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="765"
        y="500"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('fl')"
        (mouseover)="onHover('Florida', 'fl', $event)"
        (mouseleave)="onmouseLeave('fl')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">FL</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="715"
        y="400"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('ga')"
        (mouseover)="onHover('Georgia', 'ga', $event)"
        (mouseleave)="onmouseLeave('ga')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">GA</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="374"
        y="570"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('hi')"
        (mouseover)="onHover('Hawaii', 'hi', $event)"
        (mouseleave)="onmouseLeave('hi')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">HI</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="195"
        y="145"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('id')"
        (mouseover)="onHover('Idaho', 'id', $event)"
        (mouseleave)="onmouseLeave('id')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">ID</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="598"
        y="253"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('il')"
        (mouseover)="onHover('Illinois', 'il', $event)"
        (mouseleave)="onmouseLeave('il')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">IL</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="645"
        y="253"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('in')"
        (mouseover)="onHover('Indiana', 'in', $event)"
        (mouseleave)="onmouseLeave('in')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">IN</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="525"
        y="213"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('ia')"
        (mouseover)="onHover('Iowa', 'ia', $event)"
        (mouseleave)="onmouseLeave('ia')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">IA</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="445"
        y="290"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('ks')"
        (mouseover)="onHover('Kansas', 'ks', $event)"
        (mouseleave)="onmouseLeave('ks')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">KS</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="675"
        y="300"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('ky')"
        (mouseover)="onHover('Kentucky', 'ky', $event)"
        (mouseleave)="onmouseLeave('ky')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">KY</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="549"
        y="447"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('la')"
        (mouseover)="onHover('Louisiana', 'la', $event)"
        (mouseleave)="onmouseLeave('la')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">LA</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="892"
        y="80"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('me')"
        (mouseover)="onHover('Maine', 'me', $event)"
        (mouseleave)="onmouseLeave('me')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">ME</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="858"
        y="270"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('md')"
        (mouseover)="onHover('Maryland', 'md', $event)"
        (mouseleave)="onmouseLeave('md')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">MD</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="910"
        y="137"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('ma')"
        (mouseover)="onHover('Massachusetts', 'ma', $event)"
        (mouseleave)="onmouseLeave('ma')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">MA</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="658"
        y="174"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('mi')"
        (mouseover)="onHover('Michigan', 'mi', $event)"
        (mouseleave)="onmouseLeave('mi')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">MI</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="505"
        y="127"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('mn')"
        (mouseover)="onHover('Minnesota', 'mn', $event)"
        (mouseleave)="onmouseLeave('mn')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">MN</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="603"
        y="410"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('ms')"
        (mouseover)="onHover('Mississippi', 'ms', $event)"
        (mouseleave)="onmouseLeave('ms')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">MS</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="540"
        y="288"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('mo')"
        (mouseover)="onHover('Missouri', 'mo', $event)"
        (mouseleave)="onmouseLeave('mo')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">MO</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="287"
        y="90"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('ma')"
        (mouseover)="onHover('Montana', 'mt', $event)"
        (mouseleave)="onmouseLeave('mt')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">MT</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="424"
        y="226"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('ne')"
        (mouseover)="onHover('Nebraska', 'ne', $event)"
        (mouseleave)="onmouseLeave('ne')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">NE</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="140"
        y="235"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('nv')"
        (mouseover)="onHover('Nevada', 'nv', $event)"
        (mouseleave)="onmouseLeave('nv')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">NV</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="850"
        y="75"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('nh')"
        (mouseover)="onHover('New Hampshire', 'nh', $event)"
        (mouseleave)="onmouseLeave('nh')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">NH</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="860"
        y="224"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('nj')"
        (mouseover)="onHover('New Jersey', 'nj', $event)"
        (mouseleave)="onmouseLeave('nj')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">NJ</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="304"
        y="369"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('nm')"
        (mouseover)="onHover('New Mexico', 'nm', $event)"
        (mouseleave)="onmouseLeave('nm')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">NM</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="816"
        y="151"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('ny')"
        (mouseover)="onHover('New York', 'ny', $event)"
        (mouseleave)="onmouseLeave('ny')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">NY</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="787"
        y="327"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('nc')"
        (mouseover)="onHover('North Carolina', 'nc', $event)"
        (mouseleave)="onmouseLeave('nc')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">NC</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="420"
        y="97"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('nd')"
        (mouseover)="onHover('North Dakota', 'nd', $event)"
        (mouseleave)="onmouseLeave('nd')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">ND</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="700"
        y="240"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('oh')"
        (mouseover)="onHover('Ohio', 'oh', $event)"
        (mouseleave)="onmouseLeave('oh')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">OH</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="460"
        y="358"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('ok')"
        (mouseover)="onHover('Oklahoma', 'ok', $event)"
        (mouseleave)="onmouseLeave('ok')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">OK</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="103"
        y="123"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('or')"
        (mouseover)="onHover('Oregon', 'or', $event)"
        (mouseleave)="onmouseLeave('or')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">OR</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="783"
        y="210"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('pa')"
        (mouseover)="onHover('Pennsylvania', 'pa', $event)"
        (mouseleave)="onmouseLeave('pa')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">PA</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="900"
        y="190"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('ri')"
        (mouseover)="onHover('Rhode Island', 'ri', $event)"
        (mouseleave)="onmouseLeave('ri')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">RI</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="761"
        y="370"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('sc')"
        (mouseover)="onHover('South Carolina', 'sc', $event)"
        (mouseleave)="onmouseLeave('sc')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">SC</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="420"
        y="161"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('sd')"
        (mouseover)="onHover('South Dakota', 'sd', $event)"
        (mouseleave)="onmouseLeave('sd')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">SD</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="656"
        y="339"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('tn')"
        (mouseover)="onHover('Tennessee', 'tn', $event)"
        (mouseleave)="onmouseLeave('tn')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">TN</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="429"
        y="450"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('tx')"
        (mouseover)="onHover('Texas', 'tx', $event)"
        (mouseleave)="onmouseLeave('tx')"
        (mouseout)="onMouseout()"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">TX</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="224"
        y="254"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('ut')"
        (mouseover)="onHover('Utah', 'ut', $event)"
        (mouseleave)="onmouseLeave('ut')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">UT</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="830"
        y="90"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('vt')"
        (mouseover)="onHover('Vermont', 'vt', $event)"
        (mouseleave)="onmouseLeave('vt')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">VT</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="788"
        y="282"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('va')"
        (mouseover)="onHover('Virginia', 'va', $event)"
        (mouseleave)="onmouseLeave('va')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">VA</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="125"
        y="50"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('w3')"
        (mouseover)="onHover('Washington', 'wa', $event)"
        (mouseleave)="onmouseLeave('wa')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">WA</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="742"
        y="269"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('wv')"
        (mouseover)="onHover('West Virginia', 'wv', $event)"
        (mouseleave)="onmouseLeave('wv')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">WV</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="578"
        y="156"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('wi')"
        (mouseover)="onHover('Wisconsin', 'wi', $event)"
        (mouseleave)="onmouseLeave('wi')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">WI</tspan>
      </text>
      <text
        style="cursor: pointer"
        x="300"
        y="183"
        text-anchor="middle"
        stroke="none"
        [attr.fill]="fillColor"
        (click)="onUsMapClick('wy')"
        (mouseover)="onHover('Wyoming', 'wy', $event)"
        (mouseleave)="onmouseLeave('wy')"
        (mouseout)="onMouseout()"
      >
        <tspan dy="6.5">WY</tspan>
      </text>
      <line
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="#C0C0C0"
        stroke-width="2"
        x1="830"
        y1="93"
        x2="845"
        y2="120"
      />
      <line
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="#C0C0C0"
        stroke-width="2"
        x1="850"
        y1="78"
        x2="865"
        y2="120"
      />
      <line
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="#C0C0C0"
        stroke-width="2"
        x1="898"
        y1="140"
        x2="875"
        y2="155"
      />
      <line
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="#C0C0C0"
        stroke-width="2"
        x1="892"
        y1="188"
        x2="878"
        y2="173"
      />
      <line
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="#C0C0C0"
        stroke-width="2"
        x1="880"
        y1="198"
        x2="858"
        y2="175"
      />
      <line
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="#C0C0C0"
        stroke-width="2"
        x1="840"
        y1="215"
        x2="850"
        y2="220"
      />
      <line
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="#C0C0C0"
        stroke-width="2"
        x1="828"
        y1="248"
        x2="842"
        y2="249"
      />
      <line
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="#C0C0C0"
        stroke-width="2"
        x1="802"
        y1="245"
        x2="845"
        y2="269"
      />
      <g id="DC">
        <path id="DC1" d="M801.8,253.8 l-1.1-1.6 -1-0.8 1.1-1.6 2.2,1.5z" />
        <circle
          id="DC2"
          fill="#D3D3D3"
          stroke="#FFFFFF"
          stroke-width="1.5"
          cx="801.3"
          cy="251.8"
          r="5"
          opacity="0"
        />
        <!-- Set opacity to "0" to hide DC circle -->
      </g>
    </g>
  </svg>
</div>
<div class="text-center mt-5">
  <!-- <a class="page-btn mx-1" (click)="close()">Close</a> -->
  <div></div>
</div>
